import gql from 'graphql-tag';

export default gql`
  mutation AUTH_UPDATE_PROFILE($profile: UserProfileInput!) {
    authUpdateProfile(profile: $profile)
  }
`
